import CategoriesComponent from '@views/categories/index';
import CategoryCompleteComponent from '@views/categories/complete';
import FlashcardComponent from '@views/categories/flashcards/show';
import FlashcardV2Component from '@views/categories/flashcards-v2/show';

export default [
  {
    path: '/categories/:categoryId?',
    name: 'categories#index',
    component: CategoriesComponent,
    meta: {
      header: true,
      masteryHeader: true,
    },
  },
  {
    path: '/categories/:categoryId/flashcards/:flashcardId?',
    name: 'categories#flashcard',
    component: FlashcardComponent,
    meta: {
      header: true,
      masteryFooter: true,
    },
  },
  {
    path: '/categories/:categoryId/flashcards-v2/:flashcardId?',
    name: 'categories#flashcard-v2',
    component: FlashcardV2Component,
    meta: {
      header: true,
      masteryFooter: true,
    },
  },
  {
    path: '/qotd/:categoryId/flashcards-v2/:flashcardId?',
    name: 'qotd#flashcard-v2',
    component: FlashcardV2Component,
    meta: {
      header: true,
      masteryFooter: true,
    },
  },
  {
    path: '/categories/:categoryId/complete',
    name: 'categories#complete',
    component: CategoryCompleteComponent,
  },
  {
    path: '/category-types/:categoryTypeId/complete',
    name: 'categoryTypes#complete',
    component: CategoryCompleteComponent,
  },
  {
    path: '/category-types/:categoryTypeId',
    name: 'categoryTypes#index',
    component: CategoriesComponent,
    meta: {
      header: true,
      masteryFooter: true,
      masteryHeader: true,
    },
  },
  {
    path: '/category-types/:categoryTypeId/flashcards-v2/:flashcardId?',
    name: 'categoryTypes#flashcard-v2',
    component: FlashcardV2Component,
    meta: {
      header: true,
      masteryFooter: true,
    },
  },
];
